import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityViverosGrupoEspecieState,
  entityViverosGrupoEspecieAdapter
} from './entity-viveros-grupo-especie.state';

import {
  entityViverosGrupoEspecieAddFailure,
  entityViverosGrupoEspecieAddRequest,
  entityViverosGrupoEspecieAddSuccess,
  entityViverosGrupoEspecieChangeRequest,
  entityViverosGrupoEspecieChangeSuccess,
  entityViverosGrupoEspecieDeleteFailure,
  entityViverosGrupoEspecieDeleteRequest,
  entityViverosGrupoEspecieDeleteSuccess,
  entityViverosGrupoEspecieLoadFailure,
  entityViverosGrupoEspecieLoadRequest,
  entityViverosGrupoEspecieLoadSuccess
} from './entity-viveros-grupo-especie.actions';
import {
  entityActividadesGrupoEspecieDeleteFailure,
  entityActividadesGrupoEspecieDeleteRequest,
  entityActividadesGrupoEspecieDeleteSuccess
} from '../entity-actividades-grupo-especie/entity-actividades-grupo-especie.actions';
import { entityActividadesGrupoEspecieAdapter } from '../entity-actividades-grupo-especie/entity-actividades-grupo-especie.state';

const reducer = createReducer(
  initialState,
  // load
  on(entityViverosGrupoEspecieLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    hasAddedSuccess: false,
    error: null
  })),
  on(entityViverosGrupoEspecieLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityViverosGrupoEspecieLoadSuccess, (state, { items }) =>
    entityViverosGrupoEspecieAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityViverosGrupoEspecieAddRequest, (state) => ({
    ...state,
    isLoading: true,
    hasAddedSuccess: false,
    error: null
  })),
  on(entityViverosGrupoEspecieAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityViverosGrupoEspecieChangeSuccess, (state, { item }) =>
    entityViverosGrupoEspecieAdapter.upsertMany(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  on(entityViverosGrupoEspecieAddSuccess, (state, { item }) =>
    entityViverosGrupoEspecieAdapter.addMany(item, {
      ...state,
      isLoading: false,
      hasAddedSuccess: true,
      error: null
    })
  ),
  on(entityViverosGrupoEspecieChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  // change
  // on(entityActividadesGrupoEspecieChangeRequest, (state) => ({
  //   ...state,
  //   isLoading: true,
  //   error: null
  // })),
  // on(entityActividadesGrupoEspecieChangeFailure, (state, { error }) => ({
  //   ...state,
  //   isLoading: false,
  //   error: error
  // })),
  // on(entityActividadesGrupoEspecieChangeSuccess, (state, { item }) =>
  //   entityActividadesGrupoEspecieAdapter.updateOne(item, {
  //     ...state,
  //     isLoading: false,
  //     error: null
  //   })
  // ),
  // delete
  on(entityViverosGrupoEspecieDeleteRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null
  })),

  on(entityViverosGrupoEspecieDeleteFailure, (state, { error }) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: false,
    error: null
  })),

  on(entityViverosGrupoEspecieDeleteSuccess, (state, { item }) =>
    entityViverosGrupoEspecieAdapter.removeOne(item.id, {
      ...state,
      isLoading: false
    })
  )
);

export function viverosGrupoEspecieReducer(
  state: EntityViverosGrupoEspecieState | undefined,
  action: Action
) {
  return reducer(state, action);
}
